import { Tab, Tabs, Typography } from '@material-ui/core';
import { CdcaApiResponse, EmissaoStatus, GrupoAcesso } from 'common/genericTypes';
import Chip from 'components/chip';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import SuspensaoHistorico, { SuspensaoHistoricoKind } from 'components/suspensaoHistorico';
import { LgSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RootState } from 'store';
import { DetalhesCaracteristicas } from './caracteristicas';
import { DetalhesCriteriosRemuneracao } from './criteriosRemuneracao';
import { DetalhesDocumentos } from './documentos';
import { initialCdca } from './initialCdca';
import Liquidacoes from './liquidacoes';
import Historico from './historico';
import { DetalhesAditamento } from 'pages/instrumentos/detalhes/aditamentos';
import { DetalhesEventosFinanceiros } from 'common/detalhes/eventosFinanceiros';

type ComponentParams = { cdcaId: string };
type ComponentState = { initialTab?: number };

const mapStateToProps = (state: RootState) => ({
  isUsuarioControlesInternos: state.auth.usuario.grupoAcesso === GrupoAcesso.ControlesInternos,
  isUsuarioOperacoes: state.auth.usuario.grupoAcesso === GrupoAcesso.Operacoes,
  cdcaApi: state.cdcaApi,
});

type Props = ReturnType<typeof mapStateToProps> & RouteComponentProps<ComponentParams, {}, ComponentState>;

const DetalhesCdca: React.FC<Props> = (props) => {
  const {
    isUsuarioControlesInternos,
    isUsuarioOperacoes,
    cdcaApi: { getCdcaDetalhes: getCdcaDetalhesApi },
  } = props;
  const { cdcaId } = props.match.params;

  const [tabValue, setTabValue] = useState<number>(props.location.state?.initialTab ?? 0);
  const [cdcaDetalhes, setCdcaDetalhes] = useState<CdcaApiResponse>(initialCdca);
  const [loadedDetalhes, setLoadedDetalhes] = useState<Boolean>(false);

  const dispatch = useDispatch();

  const getCdcaDetalhes = useCallback(async () => {
    try {
      const result = await getCdcaDetalhesApi(dispatch, cdcaId, true);
      if (result) setCdcaDetalhes(result);
      setLoadedDetalhes(true);
    } catch (error) {}
  }, [dispatch, getCdcaDetalhesApi, cdcaId]);

  useEffect(() => {
    getCdcaDetalhes();
  }, [getCdcaDetalhes]);

  return (
    <div style={{ marginRight: 40 }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="h1">
          {'CDCA-'}
          {cdcaDetalhes.codigo ?? cdcaDetalhes.ticket}
        </Typography>
        {cdcaDetalhes.suspenso && (
          <Chip
            size="medium"
            label="SUSPENSO"
            color="error"
            style={{
              margin: 20,
            }}
          />
        )}
        {cdcaDetalhes.hasPagamentosInadimplentes && <Chip size="small" label="INADIMPLENTE" color="error" />}
      </div>
      <LgSpace />
      <HorizontalAppBar>
        <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
          <Tab label="Características da Emissão" value={0} />
          <Tab label="Critérios de Remuneração" value={1} />
          <Tab label="Eventos Financeiros" value={2} />
          <Tab label="Documentos" value={3} />
          <Tab label="Aditamentos" value={7} />
          <Tab label="Suspensões" value={4} />
          <Tab label="Histórico" value={5} />
          {(isUsuarioControlesInternos || isUsuarioOperacoes) &&
            cdcaDetalhes &&
            [EmissaoStatus.AguardandoLiquidacao, EmissaoStatus.Emitido, EmissaoStatus.ParcialmenteEmitido].includes(
              cdcaDetalhes.statusEmissao
            ) && <Tab label="Liquidações" value={6} />}
        </Tabs>
      </HorizontalAppBar>
      {tabValue === 0 && <DetalhesCaracteristicas caracteristicas={cdcaDetalhes} />}
      {tabValue === 1 && <DetalhesCriteriosRemuneracao criteriosRemuneracao={cdcaDetalhes} />}
      {tabValue === 2 && <DetalhesEventosFinanceiros eventosFinanceiros={cdcaDetalhes} />}
      {tabValue === 3 && <DetalhesDocumentos documentos={cdcaDetalhes} />}
      {tabValue === 4 && (
        <SuspensaoHistorico
          kind={SuspensaoHistoricoKind.InstrumentoFinanceiro}
          registroHistoricos={cdcaDetalhes.registro.registroHistoricos}
        />
      )}
      {tabValue === 5 && <Historico cdcaDetalhes={cdcaDetalhes} />}
      {tabValue === 6 && loadedDetalhes && (
        <Liquidacoes
          onConfirmarLiquidacaoSuccess={getCdcaDetalhes}
          liquidacaoDireta={cdcaDetalhes.criteriosRemuneracao.liquidacaoDireta}
          aguardandoLiquidacao={cdcaDetalhes.statusEmissao === EmissaoStatus.AguardandoLiquidacao}
          precoUnitarioLiquidacao={cdcaDetalhes.criteriosRemuneracao.precoUnitarioLiquidacao}
          cdcaId={cdcaId}
          instrumentoFinanceiroGuid={cdcaDetalhes.instrumentoFinanceiroGuid}
        />
      )}
      {tabValue === 7 && <DetalhesAditamento documentos={cdcaDetalhes.instrumentoFinanceiroGuid} />}
    </div>
  );
};

export default connect(mapStateToProps)(withRouter(DetalhesCdca));
